import { BaseAPI } from "@/api/baseAPI";
import apiClient from "@/api/apiClient";
import { extractApiData } from "@/utils/apiResponseHandler";
import type { Risk, ConsequenceTypes, RiskStatuses, RiskCategories } from "@/types";

class RiskAPI extends BaseAPI<Risk> {
  constructor() {
    super("risk");
  }

  /**
   * Fetch consequence types for risks.
   * @returns Promise resolving to an array of consequence types.
   */
  async fetchConsequenceTypes(): Promise<(typeof ConsequenceTypes)[keyof typeof ConsequenceTypes][]> {
    return await apiClient
      .get(`${this.model}/consequence-types`)
      .then(extractApiData);
  }

  /**
   * Fetch available risk statuses.
   * @returns Promise resolving to an array of risk statuses.
   */
  async fetchRiskStatuses(): Promise<(typeof RiskStatuses)[keyof typeof RiskStatuses][]> {
    return await apiClient
      .get(`${this.model}/risk-statuses`)
      .then(extractApiData);
  }

  /**
   * Fetch risk categories.
   * @returns Promise resolving to an array of risk categories.
   */
  async fetchRiskCategories(): Promise<(typeof RiskCategories)[keyof typeof RiskCategories][]> {
    return await apiClient
      .get(`${this.model}/categories`)
      .then(extractApiData);
  }
}

export default new RiskAPI();
